import { Header } from '../components/Header';
import { MainSlider } from '../components/Slider/Slider.js';
import { OurServices } from '../components/OurServices/OurServices.js';
import { WhoWeAre } from '../components/WhoWeAre/WhoWeAre.js';
import { Footer } from '../components/Footer';

export const HomePage = ({ lang }) => {
  return (
    <div>
      <Header />
      <MainSlider />
      <WhoWeAre />
      <OurServices />
      <Footer />
    </div>
  )
}
